export default "__VITE_ASSET__6iyegEmF__"